import { AccessController } from "../../data/models.interface"
import useQuery from "../useQuery"

export const useGetAccessControllersQuery = () => {
	const url = `${process.env.REACT_APP_ACCESS_CONTROL_BACK_URL}/access-controllers`
	return useQuery<void, AccessControllersOutput>(url)
}
interface AccessControllersOutput {
	accessControllers: AccessController[]
}
